import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from "@angular/common/http";

import { Injectable } from "@angular/core";
import { Observable, catchError, throwError } from "rxjs";
import { environment } from "src/environments/environment";
import { AuthService } from "../services/auth.service";

@Injectable()
export class HttpConfig implements HttpInterceptor {

    constructor(
        private _auth: AuthService,
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const url = /http|https/.test(req.url) ? req.url : `${environment.apiUrl}${req.url}`;
        const token = this._auth.access_token;
        // ส่ง token เฉพาะ API ของเราเท่านั้น ไม่ส่งไปโดเมนอื่น
        const setHeaders: { [name: string]: string } = token && url.startsWith(environment.apiUrl)
            ? { Authorization: `Bearer ${token}` }
            : {};
        const isLogin = url === `${environment.apiUrl}auth/login`;

        return next.handle(req.clone({ url, setHeaders })).pipe(
            catchError((err: HttpErrorResponse) => {
                // token หมดอายุ/ไม่ถูกต้อง → กลับไปหน้า login (ตอน login เอง 401 = รหัสผิด ให้หน้า login แสดงเอง)
                if (err.status === 401 && !isLogin) this._auth.logout(true);
                return throwError(() => err);
            })
        );
    }
}
